"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
exports.Type = prelude_1.t.strict({
    preview_shorthash: prelude_1.t.string,
    preview_url: prelude_1.t.string,
    files: prelude_1.t.readonlyArray(prelude_1.t.readonlyRecord(prelude_1.t.string, prelude_1.t.string)),
    transientId: prelude_1.t.string
}, 'IAGenPreviewResponse');
//# sourceMappingURL=IAGenPreviewResponse.js.map